export const defaultTheme = {
  themeDarker: '#004578',
  themeDark: '#005a9e',
  themeDarkAlt: '#106ebe',
  themePrimary: '#0078d7',
  themeSecondary: '#2b88d8',
  themeTertiary: '#71afe5',
  themeLight: '#c7e0f4',
  themeLighter: '#deecf9',
  themeLighterAlt: '#eff6fc',

  neutralDark: '#212121',
  neutralPrimary: '#333333',
  neutralSecondary: '#666666',
  neutralSecondaryAlt: '#767676',
  neutralTertiary: '#a6a6a6',
  neutralTertiaryAlt: '#c8c8c8',
  neutralQuaternary: '#d0d0d0',
  neutralQuaternaryAlt: '#dadada',
  neutralLight: '#eaeaea',
  neutralLighter: '#f4f4f4',
  neutralLighterAlt: '#f8f8f8',

  alert: '#d83b01',
  alertBackground: '#deecf9',
  black: '#000000',
  blackTranslucent40: 'rgba(0,0,0,.4)',
  blue: '#0078d7',
  blueDark: '#002050',
  blueLight: '#00bcf2',
  blueMid: '#00188f',
  error: '#a80000',
  errorBackground: '#fde7e9',
  green: '#107c10',
  greenDark: '#004b1c',
  greenLight: '#bad80a',
  info: '#107c10',
  infoBackground: '#f4f4f4',
  magenta: '#b4009e',
  magentaDark: '#5c005c',
  magentaLight: '#e3008c',
  orange: '#d83b01',
  orangeLight: '#ff8c00',
  orangeLighter: '#ea4300',
  purple: '#5c2d91',
  purpleDark: '#32145a',
  purpleLight: '#b4a0ff',
  red: '#e81123',
  redDark: '#a80000',
  success: '#107c10',
  successBackground: '#dff6dd',
  teal: '#008272',
  tealDark: '#004b50',
  tealLight: '#00b294',
  white: '#ffffff',
  whiteTranslucent40: 'rgba(255,255,255,.4)',
  yellow: '#ffb900',
  yellowLight: '#fff100'
};
